export default __webpack_public_path__ + "static/media/gameevents.221e47a1.png";